import Dygraph from 'dygraphs';
import $ from 'jquery';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/draggable.css';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/draggable';
import * as hairlineTypes from 'constants/hairlineTypes';

//
// DC: Generally, for Dygraphs, we use the npm package. However, for hairlines we needed to make fixes or changes to allow us to work with different types
//     of hairlines. This file was originally a copy of the official Dygraphs hairlines.js file, found at:
//      https://dygraphs.com/src/extras/hairlines.js                          OR
//      https://github.com/danvk/dygraphs/blob/master/src/extras/hairlines.js
//
// Most of the commented-out code is original code that we commented out. In some case it was actually comment-out in the original code.
//

/**
 * @license
 * Copyright 2013 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 *
 * Note: This plugin requires jQuery and jQuery UI Draggable.
 *
 * See high-level documentation at
 * https://docs.google.com/document/d/1OHNE8BNNmMtFlRQ969DACIYIJ9VVJ7w3dSPRJDEeIew/edit#
 */

//*global Dygraph:false */

Dygraph.Plugins.Hairlines = (function() {

  "use strict";

  /**
   * @typedef {
   *   xval:  number,      // x-value (i.e. millis or a raw number)
   *   interpolated: bool,  // alternative is to snap to closest
   *   lineDiv: !Element    // vertical hairline div
   *   infoDiv: !Element    // div containing info about the nearest points
   *   selected: boolean    // whether this hairline is selected
   * } Hairline
   */

  // We have to wait a few ms after clicks to give the user a chance to
  // double-click to unzoom. This sets that delay period.
  // var CLICK_DELAY_MS = 300;

  var hairlines = function(opt_options) {
    /* @type {!Array.<!Hairline>} */
    this.hairlines_ = [];

    // Used to detect resizes (which require the divs to be repositioned).
    this.lastWidth_ = -1;
    this.lastHeight = -1;
    this.dygraph_ = null;

    this.addTimer_ = null;
    opt_options = opt_options || {};

    this.divFiller_ = opt_options['divFiller'] || null;
  };

  hairlines.prototype.toString = function() {
    return "Hairlines Plugin";
  };

  hairlines.prototype.activate = function(g) {
    this.dygraph_ = g;
    this.hairlines_ = [];

    return {
      didDrawChart: this.didDrawChart,
      // click: this.click,
      dblclick: this.dblclick,
      dataDidUpdate: this.dataDidUpdate
    };
  };

  hairlines.prototype.detachLabels = function() {
    for (var i = 0; i < this.hairlines_.length; i++) {
      var h = this.hairlines_[i];
      $(h.lineDiv).remove();
      $(h.infoDiv).remove();
      this.hairlines_[i] = null;
    }
    this.hairlines_ = [];
  };

  // DC (17-3-2021): Most of the commented-out code in this function is from the dygraphs source code. However, unlike that code, we have now made
  //                 use of the jQueryUI Draggable Widget's 'start' and 'stop' events as well in the two functions below. I have left the code in
  //                 in case we do actually need to use it in future with the events it raises, e.g. handle `hairlineMoved` AS THE USER IS DRAGGING.
  hairlines.prototype.hairlineWasDragged = function (h, event, ui) {
    // var area = this.dygraph_.getArea();
    // var oldXVal = h.xval;
    h.xval = this.dygraph_.toDataXCoord(ui.position.left);
    this.moveHairlineToTop(h);
    this.updateHairlineDivPositions();
    this.updateHairlineInfo();
    this.updateHairlineStyles();
    // $(this).triggerHandler('hairlineMoved', {
    //   oldXVal: oldXVal,
    //   newXVal: h.xval
    // });
    // DC: Changed to this from above to mirror the call to "hairlineDeleted" below.
    // $(this).triggerHandler('hairlineMoved', [h, this.dygraph_, oldXVal, h.xval]);
    // $(this).triggerHandler('hairlinesChanged', {});
    // $(this).triggerHandler('hairlinesChanged', [h, this.dygraph_, oldXVal, h.xval]);
  };

  hairlines.prototype.hairlineDragStart = function (h, event, ui) {
    this.dragStartXval = h.xval;
  };

  hairlines.prototype.hairlineDragStop = function (h, event, ui) {
    h.xval = this.dygraph_.toDataXCoord(ui.position.left);
    this.moveHairlineToTop(h);
    this.updateHairlineDivPositions();
    this.updateHairlineInfo();
    this.updateHairlineStyles();
    $(this).triggerHandler('hairlineMoved', [h, this.dygraph_, this.dragStartXval, h.xval]);
    $(this).triggerHandler('hairlinesChanged', {});
  };

  // This creates the hairline object and returns it.
  // It does not position it and does not attach it to the chart.
  hairlines.prototype.createHairline = function (props) {
    let h;
    let self = this;
    const fixedPositionHairlineTypes = hairlineTypes.FIXED_HAIRLINE_TYPES;

    const $lineContainerDiv = $('<div/>').css({
        'width': '6px',
        'margin-left': '-3px',
        'position': 'absolute',
        'z-index': '10'
      })
      .addClass('dygraph-hairline');

    const $lineDiv = $('<div/>').css({
      'width': '1px',
      'position': 'relative',
      'left': '3px',
      'background': 'black',
      'height': '100%'
    });
    $lineDiv.appendTo($lineContainerDiv);

    let $infoDiv = '';

    $infoDiv = $('#hairline-template').clone().removeAttr('id').css({
      'position' : 'absolute'
    })

    if (props.type == hairlineTypes.DISTANCE_HAIRLINE) {
      $infoDiv = $('#hairline-template-distance').clone().removeAttr('id').css({
        'position' : 'absolute'
      })
    }

    if (props.type == hairlineTypes.EVENT_HAIRLINE) {
      $infoDiv = $('#hairline-template-event').clone().removeAttr('id').css({
        'position' : 'absolute'
      })
    }

    if (props.type == hairlineTypes.TRIGGER_HAIRLINE) {
      $infoDiv = $('#hairline-template-trigger').clone().removeAttr('id').css({
        'position' : 'absolute'
      })
    }

    if (props.type == hairlineTypes.ADVANCED_SEARCH_HAIRLINE) {
      $infoDiv = $('#hairline-template-search').clone().removeAttr('id').css({
        'position' : 'absolute'
      })
    }

    $infoDiv.show();

    if (fixedPositionHairlineTypes.indexOf(props.type) == -1){
      // Surely there's a more jQuery-ish way to do this!
      $([$infoDiv.get(0), $lineContainerDiv.get(0)])
        .draggable({
          'axis': 'x',
          'drag': function(event, ui) {
            self.hairlineWasDragged(h, event, ui);
          },
          'start': function(event, ui) {
            self.hairlineDragStart(h, event, ui);
          },
          'stop': function(event, ui) {
            self.hairlineDragStop(h, event, ui);
          }
          // TODO(danvk): set cursor here
        });
    }

    h = $.extend({
      interpolated: false,
      selected: false,
      lineDiv: $lineContainerDiv.get(0),
      infoDiv: $infoDiv.get(0),
      hairlineType: props.type
    }, props);

    var that = this;
    $infoDiv.on('click', '.hairline-kill-button', function (e) {
      that.removeHairline(h);
      $(that).triggerHandler('hairlineDeleted', [h, that.dygraph_]);
      $(that).triggerHandler('hairlinesChanged', {});
      e.stopPropagation();  // don't want .click() to trigger, below.
    }).on('click', function () {
      that.moveHairlineToTop(h);

      // For distance hairlines we would like all the corresponding ones on the other graphs to be moved to the top. Raising this event with the same
      // old and new values achieves that. The handler currently just dispatches a move action if the hairline type is DISTANCE_HAIRLINE.
      $(that).triggerHandler('hairlineMoved', [h, that.dygraph_, h.xval, h.xval]);
    });

    // DC: Added this. Now the attached event handler in graphComponentsCommon works.
    $(this).triggerHandler('hairlineCreated', [h, this.dygraph_, h.xval]);

    return h;
  };

  // Moves a hairline's divs to the top of the z-ordering.
  hairlines.prototype.moveHairlineToTop = function (h) {
    var div = this.dygraph_.graphDiv;
    $(h.infoDiv).appendTo(div);
    $(h.lineDiv).appendTo(div);

    var idx = this.hairlines_.indexOf(h);
    this.hairlines_.splice(idx, 1);
    this.hairlines_.push(h);
  };

  // Positions existing hairline divs.
  hairlines.prototype.updateHairlineDivPositions = function () {
    var g = this.dygraph_;
    const fixedPositionHairlineTypes = hairlineTypes.FIXED_HAIRLINE_TYPES;
    var layout = this.dygraph_.getArea();
    var chartLeft = layout.x, chartRight = layout.x + layout.w;
    var div = this.dygraph_.graphDiv;
    var pos = Dygraph.findPos(div);
    var box = [layout.x + pos.x, layout.y + pos.y];
    box.push(box[0] + layout.w);
    box.push(box[1] + layout.h);

    $.each(this.hairlines_, function(idx, h) {
      var left = g.toDomXCoord(h.xval);
      h.domX = left;  // See comments in this.dataDidUpdate

      $(h.lineDiv).css({
        'left': left + 'px',
        'top': layout.y + 'px',
        'height': layout.h + 'px'
      });  // .draggable("option", "containment", box);       // DC: This was commented out in the orginial Dygraphs code: https://dygraphs.com/src/extras/hairlines.js

      if (fixedPositionHairlineTypes.indexOf(h.type) !== -1) {
        $(h.infoDiv).css({
          'left': left + 'px',
          'top': layout.y + 'px',
        }).addClass('fixed');
      } else {
        $(h.infoDiv).css({
          'left': left + 'px',
          'top': layout.y + 'px',
          // DC (4-3-2021): I commented this out. I was getting an error when I tried to drag after making synchronization changes:
          //                cannot call methods on draggable prior to initialization; attempted to call method 'option'
          // DC (8-3-2021): Turns out that this call is responsible for ensuring the hairline cannot be dragged beyong the graph limits.
          //                The error no longer occurs now the drag stop event is utilized for synchronization of distance hairlines.
        }).draggable("option", "containment", box);
      }

      let leftCssClass = 'left-flip';
      let rightCssClass = 'right-flip';
      let rightFlip = false;
      let leftFlip = false;
      if (h.domX > (chartRight - $(h.infoDiv).outerWidth())) {
        rightFlip = true;
      }

      if (h.domX < (chartLeft + $(h.infoDiv).outerWidth())) {
        leftFlip = true;
      }

      if (rightFlip) {
        $(h.infoDiv).addClass(rightCssClass);
      } else {
        $(h.infoDiv).removeClass(rightCssClass);
      }

      if (leftFlip) {
        $(h.infoDiv).addClass(leftCssClass);
      } else {
        $(h.infoDiv).removeClass(leftCssClass);
      }

      var visible = (left >= chartLeft && left <= chartRight);
      $([h.infoDiv, h.lineDiv]).toggle(visible);
    });
  };

  // Sets styles on the hairline (i.e. "selected")
  hairlines.prototype.updateHairlineStyles = function() {
    $.each(this.hairlines_, function(idx, h) {
      $([h.infoDiv, h.lineDiv]).toggleClass('selected', h.selected);
    });
  };

  // Find prevRow and nextRow such that
  // g.getValue(prevRow, 0) <= xval
  // g.getValue(nextRow, 0) >= xval
  // g.getValue({prev,next}Row, col) != null, NaN or undefined
  // and there's no other row such that:
  //   g.getValue(prevRow, 0) < g.getValue(row, 0) < g.getValue(nextRow, 0)
  //   g.getValue(row, col) != null, NaN or undefined.
  // Returns [prevRow, nextRow]. Either can be null (but not both).
  hairlines.findPrevNextRows = function(g, xval, col) {
    var prevRow = null, nextRow = null;
    var numRows = g.numRows();
    for (var row = 0; row < numRows; row++) {
      var yval = g.getValue(row, col);
      if (yval === null || yval === undefined) continue;

      var rowXval = g.getValue(row, 0);
      if (rowXval <= xval) prevRow = row;

      if (rowXval >= xval) {
        nextRow = row;
        break;
      }
    }

    return [prevRow, nextRow];
  };

  // Fills out the info div based on current coordinates.
  hairlines.prototype.updateHairlineInfo = function() {
    //var mode = 'closest';

    var g = this.dygraph_;
    // var xRange = g.xAxisRange();
    var that = this;
    $.each(this.hairlines_, function(idx, h) {
      // To use generateLegendHTML, we synthesize an array of selected points.
      var selPoints = [];
      var labels = g.getLabels();
      var row, prevRow, nextRow;

      if (!h.interpolated) {
        // "closest point" mode.
        // TODO(danvk): make findClosestRow method public
        row = g.findClosestRow(g.toDomXCoord(h.xval));
        for (var i = 1; i < g.numColumns(); i++) {
          selPoints.push({
            canvasx: 1,  // TODO(danvk): real coordinate
            canvasy: 1,  // TODO(danvk): real coordinate
            xval: h.xval,
            yval: g.getValue(row, i),
            name: labels[i]
          });
        }
      } else {
        // "interpolated" mode.
        for (var j = 1; j < g.numColumns(); j++) {
          var prevNextRow = hairlines.findPrevNextRows(g, h.xval, j);
          prevRow = prevNextRow[0], nextRow = prevNextRow[1];

          // For x-values outside the domain, interpolate "between" the extreme
          // point and itself.
          if (prevRow === null) prevRow = nextRow;
          if (nextRow === null) nextRow = prevRow;

          // linear interpolation
          var prevX = g.getValue(prevRow, 0),
              nextX = g.getValue(nextRow, 0),
              prevY = g.getValue(prevRow, j),
              nextY = g.getValue(nextRow, j),
              frac = prevRow == nextRow ? 0 : (h.xval - prevX) / (nextX - prevX),
              yval = frac * nextY + (1 - frac) * prevY;

          selPoints.push({
            canvasx: 1,  // TODO(danvk): real coordinate
            canvasy: 1,  // TODO(danvk): real coordinate
            xval: h.xval,
            yval: yval,
            prevRow: prevRow,
            nextRow: nextRow,
            name: labels[j]
          });
        }
      }

      if (that.divFiller_) {
        that.divFiller_(h.infoDiv, {
          closestRow: row,
          points: selPoints,
          hairline: that.createPublicHairline_(h),
          dygraph: g
        });
      } else {
        var html = Dygraph.Plugins.Legend.generateLegendHTML(g, h.xval, selPoints, 10);
        $('.hairline-legend', h.infoDiv).html(html);
      }
    });
  };

  // After a resize, the hairline divs can get dettached from the chart.
  // This reattaches them.
  hairlines.prototype.attachHairlinesToChart_ = function() {
    var div = this.dygraph_.graphDiv;
    $.each(this.hairlines_, function(idx, h) {
      $([h.lineDiv, h.infoDiv]).appendTo(div);
    });
  };

  // Deletes a hairline and removes it from the chart.
  hairlines.prototype.removeHairline = function(h) {
    var idx = this.hairlines_.indexOf(h);
    if (idx >= 0) {
      this.hairlines_.splice(idx, 1);
      $([h.lineDiv, h.infoDiv]).remove();
    } else {
      // DC: I don't think this method exists. I looked in the GitHub repository. It is only called in 2 places in whole repository and I can't find any definition.
      Dygraph.warn('Tried to remove non-existent hairline.');
    }
  };

  hairlines.prototype.didDrawChart = function(e) {
    // var g = e.dygraph;

    // Early out in the (common) case of zero hairlines.
    if (this.hairlines_.length === 0) return;

    this.updateHairlineInfo();
    this.updateHairlineStyles();
    this.attachHairlinesToChart_();
    this.updateHairlineDivPositions();
  };

  hairlines.prototype.dataDidUpdate = function(e) {
    // When the data in the chart updates, the hairlines should stay in the same
    // position on the screen. didDrawChart stores a domX parameter for each
    // hairline. We use that to reposition them on data updates.
    // var g = this.dygraph_;
    // $.each(this.hairlines_, function(idx, h) {
      // AT: Added this outer condition to stop distance hairlines moving (snapping to the closest point) when graph data updates.
      // if (h.type !== hairlineTypes.DISTANCE_HAIRLINE || h.type !== hairlineTypes.EVENT_HAIRLINE) {
      //     if (h.hasOwnProperty('domX')) {
      //     h.xval = g.toDataXCoord(h.domX);
      //   }
      // }
    // });
  };

  // hairlines.prototype.click = function(e) {
  //   if (this.addTimer_) {
  //     // Another click is in progress; ignore this one.
  //     return;
  //   }

  //   var area = e.dygraph.getArea();
  //   var xval = this.dygraph_.toDataXCoord(e.canvasx);

  //   var that = this;
  //   this.addTimer_ = setTimeout(function() {
  //     that.addTimer_ = null;
  //     that.hairlines_.push(that.createHairline({xval: xval, index: that.get().length}));

  //     that.updateHairlineInfo();
  //     that.updateHairlineStyles();
  //     that.attachHairlinesToChart_();
  //     that.updateHairlineDivPositions();

  //     $(that).triggerHandler('hairlineCreated', {
  //       xval: xval
  //     });
  //     $(that).triggerHandler('hairlinesChanged', {});
  //   }, CLICK_DELAY_MS);
  // };

  hairlines.prototype.dblclick = function(e) {
    if (this.addTimer_) {
      clearTimeout(this.addTimer_);
      this.addTimer_ = null;
    }
  };

  hairlines.prototype.destroy = function() {
    this.detachLabels();
  };


  // Public API

  /**
   * This is a restricted view of this.hairlines_ which doesn't expose
   * implementation details like the handle divs.
   *
   * @typedef {
   *   xval:  number,       // x-value (i.e. millis or a raw number)
   *   interpolated: bool,  // alternative is to snap to closest
   *   selected: bool       // whether the hairline is selected.
   * } PublicHairline
   */

  /**
   * @param {!Hairline} h Internal hairline.
   * @return {!PublicHairline} Restricted public view of the hairline.
   */
  hairlines.prototype.createPublicHairline_ = function(h) {
    return {
      xval: h.xval,
      interpolated: h.interpolated,
      selected: h.selected,
      index: h.index,
      type: h.type
    };
  };

  /**
   * @return {!Array.<!PublicHairline>} The current set of hairlines, ordered
   *     from back to front.
   */
  hairlines.prototype.get = function() {
    var result = [];
    for (var i = 0; i < this.hairlines_.length; i++) {
      var h = this.hairlines_[i];
      result.push(this.createPublicHairline_(h));
    }
    return result;
  };

  /**
   * Calling this will result in a hairlinesChanged event being triggered, no
   * matter whether it consists of additions, deletions, moves or no changes at
   * all.
   *
   * @param {!Array.<!PublicHairline>} hairlines The new set of hairlines,
   *     ordered from back to front.
   */
  hairlines.prototype.set = function (hairlines) {

    // DC: The code in this method has diversified significantly from the official code in the repository: https://github.com/danvk/dygraphs/blob/master/src/extras/hairlines.js

    // Re-use divs from the old hairlines array so far as we can.
    // They're already correctly z-ordered.
    // var anyCreated = false;

    //Needed to work backwards as the indexes were being looped incorrectly, as the size of the array was decreasing
    for (let i = this.hairlines_.length - 1; i >= 0; i--) {
      this.removeHairline(this.hairlines_[i]);
    }

    for (var i = 0; i < hairlines.length; i++) {
      var h = hairlines[i];
      // this.hairlines_ = [];
      // if (this.hairlines_.length > i) {
      // //   let $infoDiv = '';

      // //   $infoDiv = $('#hairline-template').clone().removeAttr('id').css({
      // //     'position': 'absolute'
      // //   });

      // //   if (h.type == hairlineTypes.DISTANCE_HAIRLINE) {
      // //     $infoDiv = $('#hairline-template-distance').clone().removeAttr('id').css({
      // //       'position': 'absolute'
      // //     });
      // //   }

      //   // this.hairlines_[i].infoDiv = $infoDiv;
      //   this.hairlines_[i].xval = h.xval;
      //   this.hairlines_[i].interpolated = h.interpolated;
      //   this.hairlines_[i].selected = h.selected;
      //   this.hairlines_[i].index = h.index;
      //   this.hairlines_[i].type = h.type;
      // } else {
        // this.removeHairline(this.hairlines_[hairlines.length]);
        const hairlineConfig = {
          xval: h.xval,
          interpolated: h.interpolated,
          selected: h.selected,
          index: i,
          type: h.type
        };

        if (h.channelId) {
          hairlineConfig.channelId = h.channelId;
        }

        this.hairlines_.push(this.createHairline(hairlineConfig));
      //   anyCreated = true;
      //  }
    }

    // If there are any remaining hairlines, destroy them.
    // while (hairlines.length < this.hairlines_.length) {
    //   this.removeHairline(this.hairlines_[hairlines.length]);
    // }
    this.updateHairlineInfo();
    this.updateHairlineStyles();
    // if (anyCreated) {
      this.attachHairlinesToChart_();
    // }
    // DC: I had to move this so it was AFTER the call to attachHairlinesToChart_() to get the leftFlip/rightFlip code to work correctly for the
    //     synchronized distance hairlines. Previously it was evaluating the outerWidth() of the infoDiv as 0 under certain circumstances.
    this.updateHairlineDivPositions();

    $(this).triggerHandler('hairlinesChanged', {});
  };

  return hairlines;

})();

export default Dygraph;
